import React from 'react';

import ProductListStaggeredCardActions from './components/product-list-staggered-card-actions/product-list-staggered-card-actions';
import ProductListCardDetails from '../product-list-card-details/product-list-card-details';
import ProductListCardHighlight from '../product-list-card-highlight/product-list-card-highlight';
import ProductListCardPromos from '../product-list-card-promos/product-list-card-promos';

import { useProductQuantity } from '../../../../shared/hooks/hooks';

import { getNormalizedProductType } from '../../../../shared/utils/product/product';

import {
  BundleType,
  ProductData,
  ProductTypeEnum
} from '../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../shared/types/product';

import './product-list-staggered-card.scss';

interface ProductListStaggeredCardProps {
  onAddProductClick: (productItem: ProductItem) => void;
  onCheckInventoryClick: () => void;
  onViewProductClick: () => void;
  pageNum?: number;
  product: ProductData;
}

function ProductListStaggeredCard(props: ProductListStaggeredCardProps) {
  const {
    onAddProductClick,
    onCheckInventoryClick,
    onViewProductClick,
    pageNum,
    product
  } = props;

  const normalizedProductType =
    getNormalizedProductType(product) || ProductTypeEnum.Tires;
  const {
    quantity,
    rearQuantity,
    setQuantity,
    setRearQuantity,
    totalQuantity
  } = useProductQuantity({
    bundleType: product?.rearProduct ? BundleType.StaggeredSet : undefined,
    productType: normalizedProductType
  });
  const productDetailUrl = product?.url || '';

  if (window['isPreRendering']) {
    return <div styleName="container" />;
  }

  return (
    <div
      data-testid="product-list-staggered-card"
      id={product && product.code ? `product-code-${product.code}` : ''}
      styleName="container"
    >
      <ProductListCardHighlight product={product} />

      <ProductListCardDetails
        onCheckInventoryClick={onCheckInventoryClick}
        onViewProductClick={onViewProductClick}
        pageNum={pageNum}
        product={product}
        productDetailUrl={productDetailUrl}
        quantity={quantity}
        rearQuantity={rearQuantity}
        totalQuantity={totalQuantity}
      />

      <ProductListCardPromos
        product={product}
        quantity={quantity}
        rearQuantity={rearQuantity}
      />

      <ProductListStaggeredCardActions
        onAddProductClick={onAddProductClick}
        onQuantityChange={setQuantity}
        onRearQuantityChange={setRearQuantity}
        product={product}
        quantity={quantity}
        rearQuantity={rearQuantity}
        totalQuantity={totalQuantity}
      />
    </div>
  );
}

export default ProductListStaggeredCard;
